import { render, staticRenderFns } from "./TeamPlayer.vue?vue&type=template&id=6a03d436&"
import script from "./TeamPlayer.vue?vue&type=script&lang=js&"
export * from "./TeamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports